/**
 * Company: SPHMedia
 * Description: [Read more CTA]
 */

import { ReactElement } from "react";

export type ReadMoreButtonProps = {
  onClick: () => void;
  label: string;
};

/**
 * ReadMoreButton
 * Description: [Read more button for infinite scroll articles]
 * @param props
 * @returns The rendered React element
 */
export default function ReadMoreButton({
  onClick,
  label,
}: ReadMoreButtonProps): ReactElement {
  return (
    <div className="text-center mb-6 lg:mb-8">
      <div className="relative">
        <div className="absolute bg-white-100 bg-opacity-70 w-full h-[80px] bottom-0"></div>
      </div>
      <button
        data-testid="read-more-button"
        onClick={onClick}
        className="font-primary text-[12px] font-semibold text-white-100 bg-blue-400 py-[6px] px-10 leading-[150%]"
      >
        {label}
      </button>
    </div>
  );
}
